










































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import DeleteButton from "@/components/datatable/DeleteButton.vue";
import EForm from "@/components/datatable/EForm.vue";
import Number from "@/components/inputs/Number.vue";
import TextField from "@/components/inputs/TextField.vue";
import Id from "@/components/inputs/Id.vue";
import Select35 from "@/components/inputs/Select35.vue";
import debounce from 'lodash/debounce';
import { order } from "@/entity/OrderEntity";
import { adres } from "@/entity/AdresEntity";
import { PaymentTypeEntity } from "@/entity/PaymentTypeEntity";
import { DealersEntity } from "@/entity/DealersEntity";

@Component({
  components: {
    Select35,
    DeleteButton,
    EForm,
    Number,
    TextField,
    Id
  }
})
export default class Order extends Vue {
  items: order[] | null = null;
  dialog = false;
  title: string = "";
  search: string = "";
  searchInput: string = "";
  baseAction: string = "orders";
  action: string = this.baseAction;
  data: order = new order();
  paymentTypes: PaymentTypeEntity[] = [];
  dealer: DealersEntity[] = [];
  cities: any[] = [];
  isLoading: boolean = false;
  statusDialog: boolean = false;
  pendingStatusChange: any = null;
  jobReportsDialog: boolean = false;
  jobReportsLoading: boolean = false;
  jobReportsData: any = null;

  currentPage: any =  1;
  pageSize: any =  10;    // sayfa başı kayıt
  totalItems: any =  0;
  loading: any =  false;
  pendingPage: number | null = null;

  icrapro_exe_label="İcrapro Exe Satışlarını Gizle";
  referrer:boolean = false;

  sortAsc: boolean = true;

  /**
   * Rapor nesnesinden hata/açıklama mesajını çıkarır.
   * Backend farklı alanlarda mesaj döndürebilir.
   */
  extractReportMessage(report: any): string {
    if (!report) return '';
    const msg = report.message || report.forward_message || report.error_message ||
        report.error || report.msg || report.errorMessage;
    return (typeof msg === 'string' && msg.trim()) ? msg.trim() : '';
  }

  async fetchSingleReport(orderId: number) {
    const item = this.items?.find((i: any) => i.siparis.order_id === orderId);
    if (!item || item.reportData) return; // Already fetched

    this.$set(item, 'reportLoading', true);

    try {
      const response = await this.$http.post(this.$store.state.icwApiUrl + "admin/satis-job-reports", { satisIds: [orderId] });

      if (response.data && response.data.data && response.data.data[orderId] && response.data.data[orderId].length > 0) {
        const report = response.data.data[orderId][0];
        const extractedMessage = this.extractReportMessage(report);
        const errorFallback = 'İstek arka tarafa atılamadı. Onaylandı/Tamamlandı yapılmalı.';
        const displayMessage = extractedMessage || (report.status === 'error' ? errorFallback : '');

        this.$set(item, 'reportData', {
          ...report,
          message: report.message || extractedMessage || (report.status === 'error' ? errorFallback : ''),
          forward_message: report.forward_message || extractedMessage || displayMessage
        });
      } else {
        this.$set(item, 'reportData', {
          status: 'error',
          message: 'İstek arka tarafa atılamadı. Onaylandı/Tamamlandı yapılmalı.'
        });
      }
    } catch (error) {
      this.$set(item, 'reportData', {
        status: 'error',
        message: 'İstek arka tarafa atılamadı. Onaylandı/Tamamlandı yapılmalı.'
      });
    } finally {
      this.$set(item, 'reportLoading', false);
    }
  }
  headers = [
    {
      text: "Id",
      align: "start",
      sortable: true,
      value: "siparis.order_id"
    },
    { text: "Ödeme tipi", value: "siparis.payment_type_id" },
    { text: "Durum", value: "siparis.status" },
    { text: "Ad / Firma Adı", value: "adres.name" },
    { text: "Soyad", value: "adres.lastname" },
    { text: "Şehir", value: "adres.city" },
    { text: "Satış Elemanı", value: "siparis.dealerName", sortable: true },
    { text: "Tutar", value: "siparis.total_price" },
    { text: "Sipariş tarihi", value: "siparis.updated_at", sortable: true },
    { text: "Rapor", value: "report", sortable: false, align: "center" },
    { text: "İşlemler", value: "actions" }
  ];

  onSortChange(sortBy: string) {
    if (sortBy !== "siparis.updated_at" && sortBy !== "siparis.dealerName") return;

    const start = (this.currentPage - 1) * this.pageSize;
    const end = start + this.pageSize;
    const currentPageItems = this.items?.slice(start, end) || [];

    if (sortBy === "siparis.updated_at") {
      // 🗓️ Tarihe göre sıralama
      currentPageItems.sort((a: any, b: any) => {
        const dateA = new Date(a.siparis.updated_at).getTime();
        const dateB = new Date(b.siparis.updated_at).getTime();
        return this.sortAsc ? dateA - dateB : dateB - dateA;
      });
    }
    else if (sortBy === "siparis.dealerName") {
      // 👤 Satış elemanına göre alfabetik sıralama
      currentPageItems.sort((a: any, b: any) => {
        const nameA = a.siparis.dealerName?.toLowerCase() || "";
        const nameB = b.siparis.dealerName?.toLowerCase() || "";
        return this.sortAsc ? nameA.localeCompare(nameB) : nameB.localeCompare(nameA);
      });
    }

    if (this.items) {
      this.items.splice(start, currentPageItems.length, ...currentPageItems);
    }
    this.sortAsc = !this.sortAsc;
  }

  onSearchKeyUp() {
    // search value zaten v-model ile güncelleniyor
    this.debouncedSearch(); // debounce ile backend çağrısı
  }

  debouncedSearch = debounce(() => {
    this.currentPage = 1; // search değişince sayfayı başa al
    this.onReferrerChange(); // backend’den veri çek
  }, 500); // 500ms bekler, sonra çağırır

  customFilter(value: any, search: string, item: any) {
    if (search == null || search.trim() === '') return true;

    search = search.toLowerCase();
    const searchTerms = search.split(' ');

    const ad = (item?.adres?.name ?? '').toString().toLowerCase();
    const firmaAdi = (item?.adres?.company_name ?? '').toString().toLowerCase();
    const soyad = (item?.adres?.lastname ?? '').toString().toLowerCase();
    const orderId = (item?.siparis?.order_id ?? '').toString().toLowerCase();
    const dealer = (item?.siparis?.dealerName ?? '').toString().toLowerCase();

    const fieldsToSearch = [
      ad,
      firmaAdi,
      soyad,
      orderId,
      dealer
    ];

    return searchTerms.every(term =>
        fieldsToSearch.some(field =>
            field.includes(term)
        )
    );
  }

  async onStatusChange(item: any) {
    const prevStatus = item.siparis.prevStatus;
    const newStatus = item.siparis.status;

    console.log(`Durum değişiyor: ${prevStatus} -> ${newStatus}`);

    if (prevStatus === '2' && newStatus === '7') {
      // Store the pending change and show dialog
      this.pendingStatusChange = item;
      this.statusDialog = true;
      return;
    }

    // For other status changes, just update the previous status
    item.siparis.prevStatus = newStatus;
  }
  cancelStatusChange() {
    if (this.pendingStatusChange) {
      this.pendingStatusChange.siparis.status = this.pendingStatusChange.siparis.prevStatus;
    }
    this.statusDialog = false;
    this.pendingStatusChange = null;
  }

  async onReferrerChange() {
    if (this.loading) return; // zaten yükleniyorsa çık
    this.loading = true;
    try {
      // label güncelle
      if (this.referrer) {
        this.icrapro_exe_label = "Tüm Satışları Göster";
      } else {
        this.icrapro_exe_label = "Yalnızca İcrapro Exe Satışlarını Göster";
      }


      this.dialog = false;


      const page = this.currentPage || 1;   // mevcut sayfa
      const limit = this.pageSize || 20;    // sayfa başı kayıt
      const searchTerm = this.search || ""; // search parametresi

      // referrer parametresi yalnızca status === 'all' iken değil, tüm durumlarda doğru çalışacak şekilde düzenlendi
      const referrerParam = this.referrer ? "icrapro_exe" : "";
      let response = await this.$http.get(
          `${this.baseAction}?status=${this.$route.params.status}` +
          `&referrer=${referrerParam}` +
          `&page=${page}&limit=${limit}&search=${encodeURIComponent(searchTerm)}`
      );

      // items array'ini güvenli şekilde güncelle
      const ordersArray = Array.isArray(response.data?.data)
          ? response.data.data
          : (Array.isArray(response.data) ? response.data : []);

      this.items = ordersArray.map((order: any) => ({
        ...order,
        siparis: {
          ...order.siparis,
          dealerName: this.getDealerName(order.siparis.dealer_id),
        },
        reportLoading: false,
        reportData: null,
      }));

      // pagination bilgileri
      this.totalItems = response.data?.total ?? 0;
      this.currentPage = response.data?.page ?? 1;

    } catch (error) {
      console.error("Siparişleri çekerken hata oluştu:", error);
      this.items = [];
      this.totalItems = 0;
      //this.totalPages = 1;
      this.currentPage = 1;
    } finally {
      this.loading = false;

      // Eğer kullanıcı yükleme sırasında başka bir sayfaya tıkladıysa, o sayfaya git
      if (this.pendingPage && this.pendingPage !== this.currentPage) {
        const nextPage = this.pendingPage;
        this.pendingPage = null;
        this.onPageChange(nextPage);
      }
    }
  }

  onPageChange(newPage: number) {
    // Eğer şu anda veri yükleniyorsa, tıklamayı sıraya al
    if (this.loading) {
      this.pendingPage = newPage;
      return;
    }

    // Eğer yükleme yoksa direkt çalıştır
    this.currentPage = newPage;
    this.onReferrerChange();
  }

  onPageSizeChange(newSize: number) {
    if (newSize === -1) {
      this.pageSize = this.totalItems || 999999; // hepsini getir
    } else {
      this.pageSize = newSize;
    }
    this.currentPage = 1; // yeni page size'da başa dön
    this.onReferrerChange();
  }



    async confirmStatusChange() {
    if (this.pendingStatusChange) {
      // Show processing toast
      this.$toast.info('Sipariş tamamlanıyor. Lütfen bekleyiniz...', {
        timeout: 2000
      });

      await new Promise(resolve => setTimeout(resolve, 2000));

      // Update the previous status
      this.pendingStatusChange.siparis.prevStatus = this.pendingStatusChange.siparis.status;

      // Show success toast
      this.$toast.success('Sipariş başarıyla tamamlandı!', {
        timeout: 3000
      });
    }
    this.statusDialog = false;
    this.pendingStatusChange = null;
  }

  showNot(not: string) {
    alert(not);
  }

  edit(item: order) {
    this.$store.dispatch("go", "/siparis/detay/" + item.order_id);
  }

  add() {
    this.$store.dispatch("go", "/siparis/detay/");
  }

  newTab(item: order) {
    window.open("/siparis/detay/" + item.order_id, "_blank");
  }

  getCityName(city_id: number): string {
    const cities = this.$store.state.data.cities || [];
    const city = cities.find((c: any) => c.city_id === city_id);
    return city ? city.name : 'Yükleniyor...';
  }

  getStatusName(status: number): string {
    let statusItem = this.$store.state.data.orderStatus.find(s => s.status === status);
    return statusItem ? statusItem.name : '-';
  }

  formatDate(dateString: string): string {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleDateString('tr-TR', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  }

  async loadDealers() {
    try {
      let response = await this.$http.get('dealer');
      this.dealer = response.data;
    } catch (error) {
      console.error("Dealer verilerini yüklerken hata oluştu:", error);
    }
  }

  getDealerName(dealer_id: string | number | null): string {
    if (!dealer_id) {
      return 'N/A';
    }
    let dealer = this.dealer.find(d => String(d.id) === String(dealer_id));
    return dealer ? `${dealer.name} ${dealer.lastname}` : 'N/A';
  }

  async jobReports() {
    if (!this.items || this.items.length === 0) {
      this.$toast.warning("Rapor oluşturmak için sipariş bulunamadı.");
      return;
    }

    this.jobReportsDialog = true;
    this.jobReportsLoading = true;
    this.jobReportsData = null;

    try {
      const satisIds = this.items.map((item: any) => item.siparis.order_id);

      const response = await this.$http.post(this.$store.state.icwApiUrl + "admin/satis-job-reports", { satisIds });

      this.jobReportsData = response.data;

      // Toast notifications for immediate feedback
      if (response.data.success) {
        this.$toast.success("İş raporu başarıyla oluşturuldu!");
      } else {
        this.$toast.error("İş raporu oluşturulurken hata oluştu!");
      }

    } catch (error) {
      console.error("Job reports error:", error);
      this.jobReportsData = {
        success: false,
        message: "Sunucu ile bağlantı kurulurken hata oluştu. Lütfen daha sonra tekrar deneyin.",
        error: error.message
      };
      this.$toast.error("İş raporu alınamadı!");
    } finally {
      this.jobReportsLoading = false;
    }
  }

  closeJobReportsDialog() {
    this.jobReportsDialog = false;
    this.jobReportsData = null;
  }

  getReportStatusColor(status: string): string {
    switch (status?.toLowerCase()) {
      case 'completed':
      case 'tamamlandi':
      case 'success':
        return 'success';
      case 'pending':
      case 'bekliyor':
      case 'waiting':
        return 'warning';
      case 'failed':
      case 'basarisiz':
      case 'error':
        return 'error';
      case 'processing':
      case 'isleniyor':
        return 'info';
      default:
        return 'grey';
    }
  }

  async get() {
    //this.dialog = false;
    await this.loadDealers();
    await this.onReferrerChange();
    /*let response = await this.$http.get(this.baseAction + "?status=" + this.$route.params.status);
    this.cities = await this.$store.dispatch("getCities");
    this.items = response.data.map((order: any) => {
      return {
        ...order,
        siparis: {
          ...order.siparis,
          dealerName: this.getDealerName(order.siparis.dealer_id),
        },
        reportLoading: false,
        reportData: null,
      };
    });*/
  }

  getStatusClass(status: string) {
    switch (status?.toUpperCase()) {
      case 'COMPLETED':
        return 'tooltip-completed';
      case 'PENDING':
      case 'WAITING':
        return 'tooltip-pending';
      case 'ERROR':
      case 'FAILED':
        return 'tooltip-error';
      default:
        return '';
    }
  }

  async created() {
    this.paymentTypes = await this.$store.dispatch("getPaymentTypes");
    await this.$store.dispatch("getOrderStatus");
    await this.$store.dispatch("getCities"); // 🔹 added to load city list
    await this.get();
    await this.loadDealers();
    this.items?.forEach((item: any) => {
      item.siparis.prevStatus = item.siparis.status;
    });
  }
};
